import RNPrint from 'react-native-print';
import moment from 'moment';
import {Platform} from 'react-native';

export default async function AdvanceReceipt(dat: any, dat1: any) {
  let html = `<html><head><meta charset="utf-8">
  <style>
    @page { margin: 0.5cm; }
    img { width:100%; max-width:300px; height:100%; max-height:100px; }
    .invoice-box { max-width: 800px; margin: auto; padding: 15px;border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15); font-size: 14px; line-height: 24px;
    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif; color: #555; }
    table { width: 100%; line-height: inherit; text-align: left; border-collapse: collapse; }
    td { padding: 5px; vertical-align: top; }
    .heading td { background: #eee; border-bottom: 1px solid #ddd; font-weight: bold; }
    .item td { border-bottom: 1px solid #eee; }
  </style></head><body>`;

  let rooms = '';
  dat.data.ci_details?.forEach((element: any) => {
    const room = dat1.cm_room.find(
      (v: any) => v.rm_id === element.cd_room,
    )?.rm_name;
    if (room) rooms += room + ', ';
  });
  rooms = rooms.replace(/,\s*$/, '');

  html += `
    <div class="invoice-box">
      <table>
        <tr class="top">
          <td colspan="4">
            <table>
              <tr>
                <td>${dat1.cm_logo ? `<img src="${dat1.cm_logo}" alt="Logo" />` : `<b>${dat1.cm_name || ''}</b>`}</td>
                <td style="text-align:right">
                  <b>${dat1.cm_name}</b><br/>
                  ${dat1.cm_addr1}<br/>
                  ${dat1.cm_addr2},
                  ${dat1.cm_addr3}<br/>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr><td colspan="4" style="border-top:1px solid black; border-bottom:1px solid black; text-align:center"><b>Receipt</b></td></tr>
        <tr><td>Receipt #:</td><td>${
          dat.data.ci_rcptno ?? dat.data.ca_no
        }</td><td>Date</td><td>${moment(
    dat.data.ci_date ?? dat.data.ca_date,
    'YYYY/MM/DD HH:mm:ss',
  ).format('DD-MMM-YY')}</td></tr>
        <tr><td>Mobile</td><td colspan="3">${dat.data.ab_mobile}</td></tr>
        <tr><td>Name</td><td colspan="3">${dat.data.ab_name}</td></tr>
        <tr><td>Arrival</td><td>${moment(
          dat.data.ci_arrvial,
          'YYYY/MM/DD HH:mm:ss',
        ).format('DD-MMM-YY HH:mm:ss')}</td><td>Departure</td><td>${moment(
    dat.data.ci_depature,
    'YYYY/MM/DD HH:mm:ss',
  ).format('DD-MMM-YY HH:mm:ss')}</td></tr>
        <tr><td>Days</td><td colspan="3">${dat.data.ci_days}</td></tr>
        <tr><td>Advance Amount</td><td>₹ ${Number(
          dat.data.ci_advamt ?? dat.data.ca_amt,
        ).toFixed(2)}</td><td>Mode</td><td>${dat1.ci_mode ?? dat1.ca_mode} ${
    dat.data.ci_refno ?? dat.data.ca_refno ?? ''
  } ${dat.data.ci_refbank ?? dat.data.ca_refbank ?? ''}</td></tr>
        <tr><td>Narration</td><td colspan="3">Amount Received Towards Room ${rooms}${(dat.data.ci_remarks ?? dat.data.ca_remarks) ? ` - ${dat.data.ci_remarks ?? dat.data.ca_remarks}` : ''}</td></tr>
        <tr style="height: 40px"><td colspan="4"></td></tr>
        <tr><td>Receptionist</td><td style="text-align:center">GM</td><td style="text-align:center">Accounts</td><td style="text-align:right">Guest Sign</td></tr>
        <tr><td colspan="4" style="text-align:center">Thank You, Visit Us Again</td></tr>
      </table>
    </div>`;

  html += '</body></html>';

  if (Platform.OS === 'web') {
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  } else {
    await RNPrint.print({html});
  }
}

